export default __webpack_public_path__ + "static/media/logo.c0f82d02.svg";